import React, { useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import ListaFidelity from './ListaFidelity';
import NuovoFidelity from './Nuovo';
import ModificaFidelity from './Modifica';
import { useAuth } from '../../contexts/Auth';
import { isDelegato, isDelegatoRegionale } from '../../libs/utils/auth';
import FidelityIncompleti from './Incompleti';

const Fidelity = () => {
  const [{ profile }] = useAuth();

  const SIDEBAR_ITEMS = useMemo(() => {
    const commonSections = [
      { href: '/fidelity', label: 'Tutti i Fidelity' },
      { href: '/fidelity/incompleti', label: 'Fidelity incompleti' },
    ];

    if (!isDelegatoRegionale(profile)) {
      return [
        ...commonSections,
        { href: '/fidelity/nuovo', label: 'Nuovo Fidelity' },
      ];
    }

    return commonSections;
  }, [profile]);

  return (
    <div className='grid w-full grid-cols-12 gap-8 px-4 pb-10 pt-7 lg:py-12 lg:px-10'>
      <Sidebar items={SIDEBAR_ITEMS} />

      <div className='col-span-12 lg:col-span-9 xl:col-span-10'>
        <Routes>
          <Route index element={<ListaFidelity />} />
          <Route path='nuovo' element={<NuovoFidelity />} />
          <Route path='incompleti' element={<FidelityIncompleti />} />
          <Route path=':id/*' element={<ModificaFidelity />} />
        </Routes>
      </div>
    </div>
  );
};

export default Fidelity;
